 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		22: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		22: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~desktop-components-Button-index-js~desktop-components-Channel-index-js~desktop-components-Co~1befbbc3","1":"vendors~desktop-components-Button-index-js~desktop-components-Channel-index-js~desktop-components-Co~22a9eb99","2":"vendors~desktop-components-Button-index-js~desktop-components-Channel-index-js~desktop-components-Co~8cdeea9a","3":"vendors~desktop-components-DailyProgram-index-js~desktop-index-js","4":"desktop-components-Button-index-js","5":"desktop-components-Channel-index-js","6":"desktop-components-Collapsible-index-js","7":"desktop-components-DailyProgram-index-js","8":"desktop-components-Date-index-js","9":"desktop-components-Icon-index-js","10":"desktop-components-Link-index-js","11":"desktop-components-Loader-index-js","12":"desktop-components-Program-index-js","13":"desktop-components-Scrollbar-index-js","14":"desktop-components-Sidebar-index-js","15":"desktop-components-Text-index-js","16":"desktop-components-Title-index-js","17":"desktop-index-js","18":"desktop-reducers-index-js","19":"lib-patchEPG-index-js","20":"lib-polyfills-index-js","21":"lib-touchTracker-index-js","23":"mobile-index-js","24":"polyfill-intersection-observer","25":"polyfill-intl","26":"polyfill-intl-relativetimeformat","27":"polyfill-intl-rtf-az-js-locale","28":"polyfill-intl-rtf-et-js-locale","29":"polyfill-intl-rtf-ka-js-locale","30":"polyfill-intl-rtf-kk-js-locale","31":"polyfill-intl-rtf-lt-js-locale","32":"polyfill-intl-rtf-lv-js-locale","33":"polyfill-intl-rtf-ro-js-locale","34":"polyfill-intl-rtf-ru-js-locale","35":"polyfill-intl-rtf-uk-js-locale","36":"vendors~desktop-components-Link-index-js","37":"vendors~polyfill-intl","38":"vendors~polyfill-intl-az-js-locale","39":"vendors~polyfill-intl-et-js-locale","40":"vendors~polyfill-intl-ka-js-locale","41":"vendors~polyfill-intl-kk-js-locale","42":"vendors~polyfill-intl-pluralrules","43":"vendors~polyfill-intl-rtf-en-js-locale"}[chunkId]||chunkId) + "." + {"0":"be4e07dc","1":"6ef9cc99","2":"8c1c42cd","3":"53670c06","4":"f07073e5","5":"d280e246","6":"21bc7d05","7":"c54be880","8":"02d81940","9":"b42c4e7b","10":"4e31f2fc","11":"7eeffb0d","12":"6c4fe730","13":"0d859c28","14":"b8f197e5","15":"b191d23c","16":"5c370da0","17":"a2feaad9","18":"c9d397e9","19":"e13c0d84","20":"576be157","21":"7bb0ec06","23":"270c9031","24":"d97e98bb","25":"44f58a30","26":"8a1a37fa","27":"f4af2645","28":"dcbca4b3","29":"88da9a46","30":"6543e7d2","31":"aa7ea822","32":"927786b0","33":"872b56ab","34":"b53318f1","35":"872c439a","36":"d2b315fc","37":"5a514b05","38":"138b2dd2","39":"0c47aa90","40":"1de6ef10","41":"b00db262","42":"81722121","43":"a4470599","44":"6c8d56fc"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"23":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~desktop-components-Button-index-js~desktop-components-Channel-index-js~desktop-components-Co~1befbbc3","1":"vendors~desktop-components-Button-index-js~desktop-components-Channel-index-js~desktop-components-Co~22a9eb99","2":"vendors~desktop-components-Button-index-js~desktop-components-Channel-index-js~desktop-components-Co~8cdeea9a","3":"vendors~desktop-components-DailyProgram-index-js~desktop-index-js","4":"desktop-components-Button-index-js","5":"desktop-components-Channel-index-js","6":"desktop-components-Collapsible-index-js","7":"desktop-components-DailyProgram-index-js","8":"desktop-components-Date-index-js","9":"desktop-components-Icon-index-js","10":"desktop-components-Link-index-js","11":"desktop-components-Loader-index-js","12":"desktop-components-Program-index-js","13":"desktop-components-Scrollbar-index-js","14":"desktop-components-Sidebar-index-js","15":"desktop-components-Text-index-js","16":"desktop-components-Title-index-js","17":"desktop-index-js","18":"desktop-reducers-index-js","19":"lib-patchEPG-index-js","20":"lib-polyfills-index-js","21":"lib-touchTracker-index-js","23":"mobile-index-js","24":"polyfill-intersection-observer","25":"polyfill-intl","26":"polyfill-intl-relativetimeformat","27":"polyfill-intl-rtf-az-js-locale","28":"polyfill-intl-rtf-et-js-locale","29":"polyfill-intl-rtf-ka-js-locale","30":"polyfill-intl-rtf-kk-js-locale","31":"polyfill-intl-rtf-lt-js-locale","32":"polyfill-intl-rtf-lv-js-locale","33":"polyfill-intl-rtf-ro-js-locale","34":"polyfill-intl-rtf-ru-js-locale","35":"polyfill-intl-rtf-uk-js-locale","36":"vendors~desktop-components-Link-index-js","37":"vendors~polyfill-intl","38":"vendors~polyfill-intl-az-js-locale","39":"vendors~polyfill-intl-et-js-locale","40":"vendors~polyfill-intl-ka-js-locale","41":"vendors~polyfill-intl-kk-js-locale","42":"vendors~polyfill-intl-pluralrules","43":"vendors~polyfill-intl-rtf-en-js-locale"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","23":"c00d9ebf","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cms-assets.megogo.net/epg/release/v3-3-0/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpmggp-epg"] = window["webpackJsonpmggp-epg"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 5);
